import { FC } from "react";
import { SubscriptionDTO } from "../../../../domain/models/dto/SubscriptionDTO";
import { useTranslation } from "react-i18next";
import { SubscriptionStatus } from "../../../../domain/enums/SubscriptionStatusEnum";

interface SubscriptionStatusLabelProps {
    subscription: SubscriptionDTO;
    wrapClassName?: string;
}

const SubscriptionStatusLabel: FC<SubscriptionStatusLabelProps> = (props) => {
    const { t } = useTranslation();
    const getSubscriptionStatusColor = () => {
        switch (props.subscription?.status) {
            case SubscriptionStatus.ACTIVE:
                return "bg-accentGreen";
            case SubscriptionStatus.NON_ACTIVE:
                return "bg-backgroundInput";
            default:
                return "bg-backgroundInput";
        }
    };

    return (
        <div className={`flex items-center justify-center gap-3 ${props.wrapClassName}`}>
            <div
                className={`${getSubscriptionStatusColor()} flex items-center H14 text-textWhite rounded-[30px] h-[31px] dmax2:h-[26px] px-[30px] dmax2:px-5`}
            >
                {t(`subscription.status.${props.subscription?.status}`)}
            </div>
            {props.subscription?.referral && (
                <div className="flex items-center H14 text-textWhite bg-textWarning rounded-[30px] h-[31px] dmax2:h-[26px] px-[30px] dmax2:px-5">
                    {t("subscription.referral")}
                </div>
            )}
            {props.subscription?.trial && (
                <div className="flex items-center H14 text-textWhite bg-textWarning rounded-[30px] h-[31px] dmax2:h-[26px] px-[30px] dmax2:px-5">
                    {t("subscription.trial")}
                </div>
            )}
        </div>
    );
};

export default SubscriptionStatusLabel;
